module.exports = __webpack_public_path__ + "static/1-c261756168426f966f04e982110db4bc.jpg";